<template>
  <body class="mob-overflow">
    <div class="">
      <div class="mob-display common--header">
        <h4 class="navHeader textWhiteColor">HEALTH SURVEY</h4>
      </div>

      <header class="desk_display">
        <div id="header_content" class="common--header">
          <p class="alignleft"></p>
          <p class="aligncenter header-title">HEALTH SURVEY</p>
          <p class="alignright" v-on:click="gomenu()">
            <img src="images/Home@2x.png" alt v-b-toggle.sidebar-backdrop />
          </p>
        </div>
        <div style="clearaligncenter: both;"></div>
      </header>

      <b-container class="bv-example-row viewapt_height">
        <b-row align-h="center" class="row_height">
          <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 col_padding dev_position">
            <b-container class="containerstyle">
              <div class="">
                <img
                  v-if="store.enableHealthSurvey == 'true'"
                  src="images/Success.svg"
                  style=" vertical-align: middle; align-items: center;"
                />
                <img
                  v-if="store.enableHealthSurvey == 'false'"
                  src="images/Progress_Red.png"
                  style=" vertical-align: middle; align-items: center;"
                />
              </div>
              <div class="successMsgMainDiv">
                <div class="successMsgdiv">
                  <label class="thankyouText">{{ this.successMsg }}</label>
                </div>
              </div>

              <div class="desk_display buttonBottomAlign position_fixed">
                  <b-container>
                    <b-row align-h="center">
                      <b-col class="xs_col col-sm-11 col-md-12 col-lg-12 col_padding col">
                      <!-- <b-col class="col-11 col-md-9 col_padding">  -->
                         <div class="continue__controls footer_bottom">
                  <b-button type="login" variant="" v-on:click="onContinue">HOME</b-button>
                </div>
                      </b-col>
                    </b-row>
                  </b-container>
              </div>

              <div class="mob-display symptomchksuc_goHomeDivStyle">
                <div class="continue__controls">
                  <b-button type="login" variant="" v-on:click="onContinue">HOME</b-button>
                </div>
              </div>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
      <Footer></Footer>
  </body>
</template>

<script>
import { store } from "@/store.js";
import moment from "moment";
import Footer from "@/components/footer";

export default {
  name: "",
  components: {
    Footer,
  },
  data() {
    return {
      successMsg: "",
      store: store,
    };
  },
  methods: {
    onContinue(evt) {
      evt.preventDefault();
      this.$router.push({ path: "/app-home" });
    },
  },
  mounted() {
    this.store.enableHealthSurvey = window.localStorage.getItem("enableHealthSurvey");

    if (this.store.hideHealthSurvey) {
      var hour = moment(new Date()).format("HH:mm");
      if (hour >= this.store.mintodaytime && hour <= this.store.maxtodaytime) {
        window.localStorage.setItem("enableHealthSurvey", true);
        this.successMsg = store.symptomChkResponse.message;
      } else {
        window.localStorage.setItem("enableHealthSurvey", false);
        var statusString =
          "Sorry, unable to submit the Health Survey for today as the survey submission is outside of the allowable time " +
          this.store.mintodaytime12hrsFormate +
          " to " +
          this.store.maxtodaytime12hrsFormate +
          ". Please contact your group administration for more details.";
        this.successMsg = statusString;
      }
    } else {
      window.localStorage.setItem("enableHealthSurvey", true);
      this.successMsg = store.symptomChkResponse.message;
    }
  },
};
</script>
